import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAtmServiceProvider = (atmServiceProviderId: number | undefined): Promise<IGetAtmServiceProvider> => {
  return axiosDefaultApi.get(`/api/AtmServiceProviders/GetAtmServiceProviderViaID/${atmServiceProviderId}`);
};

type QueryFnType = typeof getAtmServiceProvider;

type UseGetAtmServiceProviderOptions = {
  atmServiceProviderId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAtmServiceProvider = ({ atmServiceProviderId , config }: UseGetAtmServiceProviderOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAtmServiceProvider_${atmServiceProviderId}`],
    queryFn: () => getAtmServiceProvider(atmServiceProviderId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του ATM Service Provider.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};